// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__ATPbH","header":"PatientQuestionnaire_header__yNcN1","info":"PatientQuestionnaire_info__u-Tze"};